import _objectSpread from "/Users/laurogripa/code/kusama/kappasigmamu.github.io/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
/**
 * Utilities for short weierstrass curves, combined with noble-hashes.
 * @module
 */
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
import { weierstrass } from "./abstract/weierstrass.js";
/** connects noble-curves to noble-hashes */
export function getHash(hash) {
  return {
    hash
  };
}
export function createCurve(curveDef, defHash) {
  const create = hash => weierstrass(_objectSpread(_objectSpread({}, curveDef), {}, {
    hash: hash
  }));
  return _objectSpread(_objectSpread({}, create(defHash)), {}, {
    create
  });
}